const bannesImages = [
  {
    link: "/search/trending",
    image: "https://d3px821xl4957r.cloudfront.net/assets/images/1786706975558-0-luxuracart-banner.jpg",
  },
];

const bannerMobileImages = [
  {
    link: "/search/trending",
    image: "https://d3px821xl4957r.cloudfront.net/assets/images/1786707084808-0-luxuracart-banner-m.jpg",
  },
];

const domain = "luxuracart.com";
const domainName = "luxuracart";
const domainLogo = "/Luxura-logo.png";
const bgColor = "#151517";
const favicon = "/favicon.png";
const email = "support@luxuracart.com";
const emailGlobal = "";
const metaTitle = "Shop Premium USA Brands Online at Luxura Cart &ndash; Luxura Cart";
const metaDescription =
  "Buy online Premium USA Brands from Luxura Cart with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.";
const headerBg = "#151517";
const subMenu = "#151517";
const buttonColor = "#f7f7f7";
const address = "Luxura Ventures LLC <br />Sharjah Media City<br /> Sharjah, UAE";
const phone = "";
const addressGlobal = "";
const phoneGlobal = "";

const Host = {
  domain: domain,
  domainName: domainName,
  domainLogo: domainLogo,
  bgColor: bgColor,
  favicon: favicon,
  email: email,
  metaTitle: metaTitle,
  metaDescription: metaDescription,
  headerBg: headerBg,
  subMenu: subMenu,
  bannesImages: bannesImages,
  bannerMobileImages: bannerMobileImages,
  buttonColor: buttonColor,
  address: address,
  phone: phone,
  emailGlobal: emailGlobal,
  addressGlobal: addressGlobal,
  phoneGlobal: phoneGlobal,
};

export default Host;
